import './index.css';

import { CircularProgress, FormControlLabel, Grid, Icon, IconButton, Input, InputAdornment, InputLabel, Switch, Tooltip } from '@material-ui/core';
import CalculateCommissionAffiliate from 'components/CalculateCommissionAffiliate';
import MyCollapse from 'components/Collapse';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import MyIcon from 'components/Icon';
import ModalActions from 'components/ModalActions';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import { functions } from 'helpers';
import React, { Component, Fragment } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { HOST_ORBITA } from 'settings';
import { cloneProductById, listProductInvoice, productDelivery, productInviteAffiliate, productStatus } from 'store/Orbita/Product/actions';

import QuickViewLinks from './QuickviewLinks';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends DispatchProp<any>, RouteComponentProps<{}> {
  active: boolean;
  changeActive: any;
  onEditProduct?: any;

  productData: any;
  productInvoice: any;
  productStatus: any;
  productInviteAffiliate: any;
  productDelivery: any;

  cloneProductById: any;
}

interface IStates {
  idProductHistory: number;

  modalStatusProduct: boolean;
  modalStatusProductArchive: boolean;
  modalCloneProduct: boolean;

  statusProduct: 'active' | 'inactive' | 'filed' | ' ';

  loading: boolean;
  loadingStatus: boolean;
  loadingStatusArchive: boolean;
  loadingCloneProduct: boolean;

  inputInviteAffiliate: string;
  inputInviteAffiliateError: boolean;

  inputDelivery: string;
  inputDeliveryError: boolean;

  productInvoiceData: any;
  actionButtonDisabled: boolean;

  numberAffiliates: number;

  validationErrors: object;
}

class QuickView extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: true,
      idProductHistory: null,
      modalStatusProduct: false,
      modalStatusProductArchive: false,
      modalCloneProduct: false,

      statusProduct: null,

      loadingStatus: false,
      loadingStatusArchive: false,

      inputInviteAffiliate: null,
      inputInviteAffiliateError: false,

      inputDelivery: null,
      inputDeliveryError: false,

      loadingCloneProduct: false,
      productInvoiceData: null,
      actionButtonDisabled: false,

      numberAffiliates: 0,
      validationErrors: {},
    };

    this.handleCloseQuickView = this.handleCloseQuickView.bind(this);

    this.handleClickModalStatusProduct = this.handleClickModalStatusProduct.bind(this);
    this.onCancelModal = this.onCancelModal.bind(this);
    this.onConfirmModal = this.onConfirmModal.bind(this);

    this.handleClickModalStatusProductArchive = this.handleClickModalStatusProductArchive.bind(this);
    this.onConfirmModalArchive = this.onConfirmModalArchive.bind(this);
    this.onCancelModalArchive = this.onCancelModalArchive.bind(this);

    this.handleClickInviteAffiliate = this.handleClickInviteAffiliate.bind(this);
    this.handleClickDelivery = this.handleClickDelivery.bind(this);

    this.handleClickModalCloneProduct = this.handleClickModalCloneProduct.bind(this);
    this.onCancelModalCloneProduct = this.onCancelModalCloneProduct.bind(this);
    this.onConfirmModalCloneProduct = this.onConfirmModalCloneProduct.bind(this);

    this.handleClickGetInvoice = this.handleClickGetInvoice.bind(this);
  }

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };
  // fecha o quickview
  handleCloseQuickView() {
    if (typeof this.props.changeActive === 'function') {
      this.props.changeActive();
    }

    this.setState({
      loading: true,
      idProductHistory: this.props.productData.id,
    });
  }

  // abre o modal de status do produto (inativo/ativo)
  handleClickModalStatusProduct() {
    this.setState({ modalStatusProduct: !this.state.modalStatusProduct });
  }

  // cancela a ação do modal de status do produto (inativo/ativo)
  onCancelModal() {
    this.handleClickModalStatusProduct();
  }

  // confirma a ação do modal de status do produto (inativo/ativo)
  onConfirmModal() {
    this.handleClickModalStatusProduct();
    this.setState({ loadingStatus: true, actionButtonDisabled: true });

    (async () => {
      try {
        await this.props.dispatch(productStatus(this.props.productData.id, this.state.statusProduct === 'active' ? 0 : 1));

        this.setState({
          statusProduct: this.state.statusProduct === 'active' ? 'inactive' : 'active',
          loadingStatus: false,
          actionButtonDisabled: false,
        });

        this.props.onEditProduct();
      } catch {
        this.setState({
          loadingStatus: false,
          actionButtonDisabled: false,
        });

        toast.error('Ops, erro ao atualizar o status do produto');
      }
    })();
  }

  // abre o modal de status do produto (apenas o state arquivar)
  handleClickModalStatusProductArchive() {
    this.setState({ modalStatusProductArchive: !this.state.modalStatusProductArchive });
  }

  // cancela a ação do modal de status do produto (arquivado)
  onCancelModalArchive() {
    this.handleClickModalStatusProductArchive();
  }

  // confirma a ação do modal de status do produto (arquivado)
  onConfirmModalArchive() {
    this.setState({
      loadingStatusArchive: true,
      actionButtonDisabled: true,
    });

    this.handleClickModalStatusProductArchive();

    (async () => {
      try {
        await this.props.dispatch(productStatus(this.props.productData.id, 2));

        this.setState({
          statusProduct: 'filed',
          loadingStatusArchive: false,
          actionButtonDisabled: false,
        });

        this.props.onEditProduct();
      } catch {
        this.setState({
          loadingStatusArchive: false,
          actionButtonDisabled: false,
        });

        toast.error('Ops, não foi possível excluir o produto');
      }
    })();
  }

  // abre o modal de clonar o produto
  handleClickModalCloneProduct() {
    this.setState({ modalCloneProduct: !this.state.modalCloneProduct });
  }

  // cancela a ação do modal de clonar o produto
  onCancelModalCloneProduct() {
    this.handleClickModalCloneProduct();
  }

  // confirma a ação do modal de clonar o produto
  onConfirmModalCloneProduct() {
    // fecha o modal
    this.handleClickModalCloneProduct();

    this.setState({
      loadingCloneProduct: true,
      actionButtonDisabled: true,
    });

    (async () => {
      try {
        await this.props.dispatch(cloneProductById(this.props.productData.id));
        this.props.history.push('/producer/product/editproduct/' + this.props.cloneProductById.product.id);

        // add scroll na página novamente
        functions.addScrollPage();
      } catch {
        toast.error('Ops, erro ao clonar o produto');

        this.setState({
          loadingCloneProduct: false,
          actionButtonDisabled: false,
        });
      }
    })();
  }

  // ao alterar o campo (convite de afiliados e entrega manual), pega o valor dele e seta no state
  handleChange = (prop: any) => (event: any) => {
    // incluindo estilo de erro no input, se algo der errado
    if (prop === 'inputInviteAffiliate') {
      this.setState({
        inputInviteAffiliateError: false,
        inputInviteAffiliate: event.target.value,
      });
    }

    if (prop === 'inputDelivery') {
      this.setState({
        inputDeliveryError: false,
        inputDelivery: event.target.value,
      });
    }
  };

  // envia o convite para o afiliado
  handleClickInviteAffiliate() {
    this.setState({
      inputInviteAffiliateError: false,
    });

    (async () => {
      try {
        await this.props.dispatch(productInviteAffiliate(this.props.productData.id, this.state.inputInviteAffiliate));

        this.setState({
          inputInviteAffiliate: '',
          inputInviteAffiliateError: false,
          numberAffiliates: this.state.numberAffiliates + 1,
        });

        if (this.props.onEditProduct) this.props.onEditProduct();
        toast.success('Sucesso, afiliado adicionado com êxito');
      } catch {
        toast.error('Ops, erro ao convidar afiliado');
      }
    })();
  }

  // envia a entrega manual
  handleClickDelivery() {
    this.setState({
      inputDeliveryError: false,
    });

    (async () => {
      try {
        await this.props.dispatch(productDelivery(this.props.productData.id, this.state.inputDelivery));

        this.setState({
          inputDelivery: '',
          inputDeliveryError: false,
        });

        toast.success('Sucesso, arquivo entregue com êxito');
      } catch (error: any) {
        if (typeof error === 'string') {
          toast.error(error);
          return;
        }
        toast.error('Ops, erro na entrega manual');
      }
    })();
  }

  // ao clicar no collapse de faturas do produto
  handleClickGetInvoice() {
    if (this.props.productData) {
      if (!this.state.productInvoiceData) {
        (async () => {
          try {
            await this.props.dispatch(listProductInvoice(this.props.productData.id));
            this.setState({ productInvoiceData: this.props.productInvoice });
          } catch {
            toast.error('Ops, erro nos dados da fatura');
            this.setState({ productInvoiceData: 0 });
          }
        })();
      }
    }
  }

  componentDidUpdate(prevProps: any) {
    const nextProps = this.props;

    if (prevProps.active === false && nextProps.active) {
      if (nextProps.productData.id && nextProps.productData.id !== this.state.idProductHistory) {
        this.setState({
          loading: true,
          inputDeliveryError: false,
          inputInviteAffiliateError: false,
        });

        (async () => {
          // zerando todas as informações
          this.setState({
            loading: false,

            inputDelivery: this.state.idProductHistory === nextProps.productData.id ? this.state.inputDelivery : '',
            inputDeliveryError: false,

            inputInviteAffiliate: this.state.idProductHistory === nextProps.productData.id ? this.state.inputInviteAffiliate : '',
            inputInviteAffiliateError: false,

            statusProduct: nextProps.productData.status,
            productInvoiceData: null,

            numberAffiliates: nextProps.productData.affiliates,
          });
        })();
      } else {
        this.setState({
          loading: false,
          actionButtonDisabled: false,
        });
      }
    }
  }

  // change status product
  handleChangeStatusProduct = () => {
    this.handleClickModalStatusProduct();
  };

  render() {
    // se o quickview estiver ativo, remove o scroll (rolon)
    this.props.active ? functions.removeScrollPage() : functions.addScrollPage();
    const productDataReceive = this.props.productData;
    let labelToggleStatus = null;

    if (this.props.productStatus.isFetching) {
      labelToggleStatus = (
        <span style={{ position: 'relative', top: '3px' }}>
          <CircularProgress size={18} />
        </span>
      );
    } else if (!this.props.productStatus.isFetching && this.state.statusProduct === 'active') {
      labelToggleStatus = 'Ativo';
    } else if (!this.props.productStatus.isFetching && this.state.statusProduct === 'inactive') {
      labelToggleStatus = 'Inativo';
    } else if (!this.props.productStatus.isFetching && this.state.statusProduct === 'filed') {
      labelToggleStatus = 'Arquivado';
    } else {
      labelToggleStatus = 'Sem status';
    }

    if (this.state.loading) {
      return (
        <React.Fragment>
          <div className={'my-quickview ' + (this.props.active ? ' -active' : '')}>
            <div className='loading' style={{ height: '100%' }}>
              <Spin tip='Carregando produto ...' />
            </div>
          </div>
          <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'}></div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={'my-quickview --quickView-product' + (this.props.active ? ' -active' : '')}>
          <div className='my-quickview__head'>
            <Grid container alignItems='center' direction='row' justify='space-between'>
              <div className='my-quickview__title'>Produto: {productDataReceive.id}</div>
              <div className='my-quickview__close' onClick={this.handleCloseQuickView}>
                <MyIcon name='icon-close' />
              </div>
            </Grid>
          </div>

          <div className='my-quickview__container'>
            <Grid container>
              <Grid
                item
                className='product__image'
                xs={4}
                sm={4}
                style={{
                  backgroundImage: `url(${productDataReceive.image ? productDataReceive.image : ''})`,
                }}
              />

              <Grid item className='product__info' xs={8} sm={8}>
                <div className='product__name' title={productDataReceive.title ? productDataReceive.title : 'Produto desconhecido'}>
                  <Truncate count={40} final={'...'}>
                    {productDataReceive.title ? productDataReceive.title : 'Produto desconhecido'}
                  </Truncate>
                </div>

                <div className='m4' />
                <div className='product__status'>
                  {!productDataReceive.has_children && (
                    <FormControlLabel
                      label={labelToggleStatus}
                      control={
                        <Switch
                          color='default'
                          defaultChecked={this.state.statusProduct === 'active' ? true : false}
                          checked={this.state.statusProduct === 'active' ? true : false}
                          disabled={true}
                          onChange={this.handleChangeStatusProduct}
                        />
                      }
                    />
                  )}
                </div>
              </Grid>
            </Grid>
            <div className='m24' />
            {!productDataReceive.has_children && (
              <Grid container>
                <Grid item className='product__table' xs={12} sm={12}>
                  <div className='product_row'>
                    <div className='row_el'>
                      <div className='el_title'>Ganhos</div>
                      <span className='fw600 clgreen'>
                        <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                          <ColoredFormattedNumber value={productDataReceive.total_gains} format={productDataReceive.currency.code} />
                        </PermissionHide>
                        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                          <em>oculto</em>
                        </PermissionHide>
                      </span>
                    </div>

                    <div className='row_el txtCenter'>
                      <div className='el_title'>Afiliados</div>
                      <span>{this.state.numberAffiliates}</span>
                    </div>

                    <div className='row_el txtCenter'>
                      <div className='el_title'>Funil Infinito</div>
                      <span className={productDataReceive.infinity_funnel ? 'fw600 clgreen' : ''}>
                        {' '}
                        {productDataReceive.infinity_funnel ? 'Ativado' : 'Desativado'}{' '}
                      </span>
                    </div>
                  </div>

                  <div className='m24' />

                  <div className='product_row --row-all-padding'>
                    <div className='row_el'>
                      <div className='el_title fw600 clgreen'>
                        {productDataReceive.charge_type === 'A' && (
                          <span>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={productDataReceive.recurring_value} format='BRL' /> recorrente
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </span>
                        )}
                        {productDataReceive.charge_type === 'N' && (
                          <Fragment>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={productDataReceive.price} format='BRL' />
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </Fragment>
                        )}
                        {productDataReceive.charge_type === 'G' && <span>Grátis</span>}
                        {(!productDataReceive.charge_type || productDataReceive.charge_type === '' || productDataReceive.charge_type === ' ') && (
                          <Fragment>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={0} format='BRL' />
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </Fragment>
                        )}
                      </div>

                      {/* comissão */}
                      {productDataReceive.charge_type === 'A' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.recurring_value}
                              commissionType={productDataReceive.recurring_comission_type}
                              commissionValue={productDataReceive.recurring_comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>
                          de Com. recorrente
                        </span>
                      )}
                      {productDataReceive.charge_type === 'N' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.price}
                              commissionType={productDataReceive.comission_type}
                              commissionValue={productDataReceive.comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>
                          de Comissão
                        </span>
                      )}
                      {productDataReceive.charge_type === 'G' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.price}
                              commissionType={productDataReceive.comission_type}
                              commissionValue={productDataReceive.comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>
                          de Comissão
                        </span>
                      )}
                      {(!productDataReceive.charge_type || productDataReceive.charge_type === ' ' || productDataReceive.charge_type === '') && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate price={0} commissionValue={0} />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>
                          de Comissão
                        </span>
                      )}
                    </div>

                    <div className='row_el'>
                      <div className='el_title'>{productDataReceive.rpc_affiliate ? productDataReceive.rpc_affiliate : 0}</div>
                      <span>RPC/A</span>
                    </div>

                    <div className='row_el'>
                      <div className='el_title'>{productDataReceive.rpc_producer ? productDataReceive.rpc_producer : 0}</div>
                      <span>RPC/P</span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}

            <div className='m24' />
            {((!productDataReceive.has_children && this.state.statusProduct && this.state.statusProduct === 'active') ||
              this.state.statusProduct === 'inactive') && (
              <React.Fragment>
                <div className='product__collpase-title'>Ações Rápidas</div>
                <div className='m8' />
                <QuickViewLinks product={productDataReceive} />

                {/* <React.Fragment>
                  <div className='m8' />
                  <MyCollapse title='Entrega Manual' icon={<Icon style={{ fontSize: 16 }}>send</Icon>} arrow={true} contentActive={false}>
                    <InputLabel htmlFor='delivery-manual' style={{ fontSize: 12 }}>E-mail do Cliente</InputLabel>
                    <Input
                      id='delivery-manual'
                      type={`text`}
                      onChange={this.handleChange('inputDelivery')}
                      margin='dense'
                      error={this.state.inputDeliveryError}
                      value={this.state.inputDelivery}
                      fullWidth
                      autoFocus={true}
                      endAdornment={
                        <InputAdornment position='end'>
                          <IconButton onClick={this.handleClickDelivery}>
                            {!this.props.productDelivery.isFetching && !this.state.inputDeliveryError &&
                              <Tooltip title='Enviar'><Icon style={{ fontSize: 16 }}>send</Icon></Tooltip>
                            }
                            {!this.props.productDelivery.isFetching && this.state.inputDeliveryError &&
                              <Tooltip title='Erro ao enviar'><Icon style={{ fontSize: 16, color: '#f44336' }}>error</Icon></Tooltip>
                            }
                            {this.props.productDelivery.isFetching && !this.state.inputDeliveryError && <CircularProgress size={20} />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </MyCollapse>
                </React.Fragment> */}
              </React.Fragment>
            )}
            <div className='m24' />
            {this.state.statusProduct === 'active' && (
              <React.Fragment>
                <div className='m8' />
                <MyCollapse title='Adicionar Afiliados' icon={<Icon style={{ fontSize: 16 }}>group_add</Icon>} arrow={true} contentActive={true}>
                  <CustomCopyToClipboard
                    text={`${HOST_ORBITA}/affiliate/invite/${productDataReceive.id}`}
                    disableUnderline={true}
                    style={{ width: '100%' }}
                  />
                  <div className='m8'></div>
                  <InputLabel htmlFor='invite-email' style={{ fontSize: 12 }}>
                    Convide por E-mail
                  </InputLabel>
                  <Input
                    id='invite-email'
                    type={'text'}
                    onChange={this.handleChange('inputInviteAffiliate')}
                    margin='dense'
                    fullWidth={true}
                    value={this.state.inputInviteAffiliate}
                    autoFocus={true}
                    disableUnderline={true}
                    error={this.isValid('inputInviteAffiliate')}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton onClick={this.handleClickInviteAffiliate}>
                          {!this.props.productInviteAffiliate.isFetching && (
                            <Tooltip title='Enviar'>
                              <Icon style={{ fontSize: 16 }}>send</Icon>
                            </Tooltip>
                          )}
                          {this.props.productInviteAffiliate.isFetching && <CircularProgress size={20} />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {!this.isValid('inputInviteAffiliate') ? null : (
                    <small
                      style={{
                        fontSize: 12,
                        color: '#dc3f53',
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      {this.errorFor('inputInviteAffiliate')}
                    </small>
                  )}
                </MyCollapse>
              </React.Fragment>
            )}
          </div>
        </div>

        <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'} onClick={this.handleCloseQuickView}></div>

        {/* modal para ativar ou desativar o produto */}
        <ModalActions
          open={this.state.modalStatusProduct}
          onClose={this.onCancelModal}
          onOk={this.onConfirmModal}
          title={`Deseja realmente ${this.state.statusProduct === 'active' ? 'inativar' : 'ativar'} este produto?`}
          buttonOk={this.state.statusProduct === 'active' ? 'Inativar' : 'Ativar'}
        />

        {/* modal para arquivar o produto */}
        <ModalActions
          open={this.state.modalStatusProductArchive}
          onClose={this.onCancelModalArchive}
          onOk={this.onConfirmModalArchive}
          title={'Deseja realmente excluir este produto? Atenção, esta operação é irreversível e automaticamente todas variações serão arquivadas!'}
          buttonOk={'Excluir'}
        />

        {/* modal para clonar o produto */}
        <ModalActions
          open={this.state.modalCloneProduct}
          onClose={this.onCancelModalCloneProduct}
          onOk={this.onConfirmModalCloneProduct}
          title={'Deseja realmente duplicar este produto? Obs: você será redirecionado para a tela de edição.'}
          buttonOk={'Duplicar'}
        />
      </React.Fragment>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    productInvoice: state.orbita.Product.productInvoice,
    productStatus: state.orbita.Product.productStatus,
    productInviteAffiliate: state.orbita.Product.productInviteAffiliate,
    productDelivery: state.orbita.Product.productDelivery,
    cloneProductById: state.orbita.Product.cloneProductById,
  };
}
export default withRouter(connect(mapStateToProps)(QuickView));
